<p [class]="(isAmministrazioneModule) ? 'col-sm-3':'col-sm-12'">
	<!-- <label for="cerca-lbl-crc">Cerca</label> <input id="cerca-lbl-crc" class="form-control"
		name="cerca" placeholder="{{ (isAmministrazioneModule) ? 'Inserisci nome':'cerca' }}" [(ngModel)]="testoScritto" type="text" (keyup)="onChange($event)"> -->
	<label for="cerca-lbl-crc-{{randomId}}">Cerca</label> 
	<input 
		id="cerca-lbl-crc-{{randomId}}" 
		name="cerca" 
		placeholder="{{ (isAmministrazioneModule ? 'Inserisci nome':'Cerca') + ' e premi invio' }}"
		type="text" 
		(keydown.enter)="onChange()" 
		class="form-control search-input"
		[(ngModel)]="testoScritto">
	<button 
		type="submit"  
		class="search-button"
		(click)="onChange()"
		aria-label="Cerca">
		<svg class="search-icon" viewBox="0 0 24 24">
		<path fill="currentColor" 
			d="M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.57 
			4.23l4.92 4.92-1.41 1.41-4.92-4.92A6.48 6.48 0 0 1 
			9.5 16 6.5 6.5 0 1 1 9.5 3zm0 2A4.5 4.5 0 1 0 
			9.5 14a4.5 4.5 0 0 0 0-9z"/>
		</svg>
	</button>
</p>